import { Link } from "react-router";
import { Row } from "../../../components/Row";
import { useDataProvider } from "../../../hooks/dataProvider";
import { useKeyedParams } from "../../../hooks/useParams";
import {
  getPage,
  setSelectedPage,
} from "../../../state/actions/tournamentActions";
import { TournamentPage } from "../../../types/tournamentTypes";
import { EditPageForm } from "./EditPageForm";
import { useDocumentTitle } from "../../../hooks/useDocumentTitle";
import { useMemo } from "react";

interface EditProps {
  pageId: string;
  secondaryId?: string;
}

export function EditTournamentWrapper() {
  const { pageId, secondaryId } = useKeyedParams<EditProps>();
  const id = useMemo(() => {
    const start = `${pageId}${secondaryId ? `/${secondaryId}` : ""}`;
    if (start.includes("(")) return start;
    return start.replace(/_/g, " ");
  }, [pageId, secondaryId]);

  const provider = useDataProvider({
    id,
    getId: (tournament) =>
      `${tournament.pageId}${
        tournament.secondaryId ? `/${tournament.secondaryId}` : ""
      }`,
    dispatchAction: setSelectedPage,
    selector: (state) => state.tournaments.selectedPage,
    getData: getPage,
    fallbackUrl: "/tournaments",
    render: (page) => {
      return <EditTournamentPage page={page} />;
    },
  });
  return provider.getPage();
}

interface Props {
  page: TournamentPage;
}
function EditTournamentPage(props: Props) {
  useDocumentTitle(
    `Editing ${props.page.pageId}${
      props.page.secondaryId ? ` ${props.page.secondaryId}` : ""
    } - BQA Tournaments`
  );
  return (
    <div className="page">
      <Row>
        <Link
          className="secondary-btn"
          style={{ marginRight: 20 }}
          to={`/tournaments/${props.page.pageId}${props.page.secondaryId ? `/${props.page.secondaryId}` : ""}`}
        >
          Go Back
        </Link>
        <h1>Edit Page</h1>
      </Row>
      <EditPageForm mode="UPDATE" page={props.page} />
    </div>
  );
}
